import { hasMany, belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';
import { computed } from '@ember/object';

export default ShModel.extend({
    personalWebsite: attr(),
    paypalEmail: attr('string'),
    maxRate: attr('number'),
    minRate: attr('number'),
    completePercent: attr('number'),  //TODO has been removed from DB, should take out.
    dayRate: computed('minRate', 'maxRate', {
        get() {
            let minRate = this.get('minRate');
            let maxRate = this.get('maxRate');
            return this.computeDayRate(minRate, maxRate, null);
        },
        set(key, value) {
            let temp = value.replace(/[^\d-]/g, '').split('-');
            let minRate = temp[0] ? temp[0] : null;
            let maxRate = temp[1] ? temp[1] : null;
            this.setProperties({minRate, maxRate});
            return this.computeDayRate(minRate, maxRate, value);
        }
    }),
    conflictReporting: attr('boolean'),
    crFullName: attr(),
    crRelationship: attr(),
    crPhone: attr(),
    crEmail: attr(),
    crFirstAidTraining: attr('boolean'),
    crFirstAidTrainingVal: attr(),
    crHostileEnvTraining: attr('boolean'),
    crHostileEnvTrainingVal: attr(),
    crInsurance: attr('boolean'),
    crInsuranceVal: attr(),
    crCitizenships: attr(),
    crLocalPhone: attr(),
    crSkype: attr(),
    publicOptOut: attr('boolean'),
    intercountryTravel: attr('boolean'),
    ipLocationOptOut: attr('boolean'),
    minProjectDays: attr('number'),

    user: belongsTo('user', { async: false }),
    equipment: hasMany('equipment', { async: false }),
    languages: hasMany('language', { async: false }),
    freelancerCalendars: hasMany('freelancerCalendar', { async: false }),

    computeDayRate(minRate, maxRate, dayRate) {
        if (minRate && maxRate) {
            dayRate = `$${minRate}-$${maxRate}`;
        } else if (minRate && !maxRate) {
            dayRate = `$${minRate}`;
        } else if (!minRate && maxRate) {
            dayRate = `$${maxRate}`;
        }
        return dayRate;
    },

    /**
     * Take an array of countries and convert them into the crCitizenships model that will actually persist it
     *
     * @param {Ember.MutableArray.<DS.Model>} countries
     */
    updateCitizenshipsFromCountries: function(countries) {
      if (countries.get('length') <= 0) {
        this.set('crCitizenships', null);
        return;
      }

      countries = countries.map(function(item) {
        return item.get('name');
      });
      this.set('crCitizenships', countries.join(';'));
    }
});
